import React from 'react';
import { BaseExceptionProps } from './exception';
import { Box, Typography } from '@mui/material';
import { OopsIcon } from '../icons';

export const ExceptionDefault: React.FC<BaseExceptionProps> = (
  props: BaseExceptionProps
) => {
  const { title, subtitle, children } = props;
  return (
    <Box
      sx={(theme) => ({
        display: 'inline-flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: props.width ?? '100%',
        height: props.height ?? '100%',
        color: theme.palette.text.secondary,
        flex: 1,
        padding: theme.spacing(2, 0),
      })}
    >
      <Box mb={1}>
        <OopsIcon color="disabled" sx={{ fontSize: 120 }}></OopsIcon>
      </Box>
      {title && <Typography variant="h6">{title}</Typography>}
      {subtitle && <Typography variant="subtitle1">{subtitle}</Typography>}
      {children}
    </Box>
  );
};

ExceptionDefault.defaultProps = {
  subtitle: '糟糕，出错啦',
};
